/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InteractiveElement, styled } from "@iventis/styles";
import { dateToTimeInputString, timeInputStringToDate } from "@iventis/utilities";
import React, { useMemo, useRef } from "react";
import { DateFilterContainer } from "./date-filter";

export interface TimeFilterProps {
    time: Date;
    incrementAmount: number;
    onTimeChange: (date: Date) => void;
}

export const TimeFilterComponent = ({ time, incrementAmount, onTimeChange }: TimeFilterProps) => {
    const timeInputRef = useRef<HTMLInputElement>();

    const changeTime = (modifier: number) => {
        const newTime = new Date(time);
        const newMinutes = newTime.getMinutes() + modifier;
        if (modifier > 0 && newMinutes % 15 !== 0) {
            // Increment the time to the next 15 minute interval
            newTime.setMinutes(newMinutes - (newMinutes % 15));
        } else if (modifier < 0 && newMinutes % 15 !== 0) {
            // Decrement the time to the previous 15 minute interval
            if (newTime.getMinutes() < 15) {
                newTime.setMinutes(0);
            } else {
                newTime.setMinutes(newMinutes - (newMinutes % 15) + 15);
            }
        } else {
            newTime.setMinutes(newMinutes);
        }
        onTimeChange(newTime);
    };

    const onTimeChangeFromInput = (value: string) => {
        const newTime = timeInputStringToDate(value);
        if (newTime !== null) {
            onTimeChange(newTime);
        }
    };

    const timeValue = useMemo(() => dateToTimeInputString(time), [time.getHours(), time.getMinutes()]);

    return (
        <DateFilterContainer>
            <InteractiveElement className="increment-button" onClick={() => changeTime(incrementAmount * -1)}>
                <FontAwesomeIcon size="lg" icon={["fas", "chevron-left"]} />
            </InteractiveElement>
            <InteractiveElement className="calendar-toggle" onClick={() => ((timeInputRef.current as unknown) as { showPicker: () => void }).showPicker()}>
                {timeValue}
            </InteractiveElement>
            <TimeInput>
                <input type="time" data-testid="date-filter-time-input" value={timeValue} ref={timeInputRef} onChange={(event) => onTimeChangeFromInput(event.target.value)} />
            </TimeInput>
            <InteractiveElement className="increment-button" onClick={() => changeTime(incrementAmount)}>
                <FontAwesomeIcon size="lg" icon={["fas", "chevron-right"]} />
            </InteractiveElement>
        </DateFilterContainer>
    );
};

const TimeInput = styled.div`
    width: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    /* Hide the input behind the button */
    z-index: -1;
`;
